import React from 'react'
import styled from 'styled-components'

import { Icon } from '../../../../components/generic'
import { colors } from '@lmc/common/constants'

const renderPayeeOptionTitle = (props) => {
  const { payee, onClick, isActive } = props

  return (
    <PayeeOptionTitleContainer $hasOnClick={!!onClick}>
      {/* Can't quite believe we need this blank div... */}
      {onClick && <Spacer />}
      <PayeeOptionTitle>{payee}</PayeeOptionTitle>
      {onClick && (
        <Icon
          name={isActive ? 'radio-on' : 'radio-off'}
          fill={isActive ? colors.pink : null}
          size={24}
        />
      )}
    </PayeeOptionTitleContainer>
  )
}

// Monthly cost section

const renderCostSubtitle = (activeResidents, preferredPeopleNominative) => {
  if (!activeResidents) {
    return 'Families will pay this'
  } else if (activeResidents < 4) {
    return 'Care Service will pay this.'
  } else {
    return (
      <div>
        Care Service will pay this. £5 x <b>{activeResidents}</b> active{' '}
        {preferredPeopleNominative} (+ VAT)
      </div>
    )
  }
}

const renderMonthlyCostSection = (props) => {
  const { costPerMonth, activeResidents, preferredPeopleNominative } = props

  return (
    <MonthlyCostContainer>
      <MonthlyCostTitle>
        {`£${costPerMonth} ${activeResidents ? '(+ VAT)' : ''} per month`}
      </MonthlyCostTitle>
      <MonthlyCostSubtitle>
        {renderCostSubtitle(activeResidents, preferredPeopleNominative)}
      </MonthlyCostSubtitle>
    </MonthlyCostContainer>
  )
}

//  Cost text section

const renderCostBulletPoints = (props) => {
  const { bulletPoint1, bulletPoint2, bulletPoint3 } = props
  return (
    <CostMainText>
      <CostBulletPoints>
        <BulletItem>{bulletPoint1}</BulletItem>
        <BulletItem>{bulletPoint2}</BulletItem>
        <BulletItem>{bulletPoint3}</BulletItem>
      </CostBulletPoints>
    </CostMainText>
  )
}

const renderCostTextSection = (props) => {
  const { bulletPoint1, bulletPoint2, bulletPoint3, mainText } = props

  return (
    <CostTextSectionContainer>
      <CostMainText $marginBottom={8}>{mainText}</CostMainText>
      {renderCostBulletPoints({ bulletPoint1, bulletPoint2, bulletPoint3 })}
    </CostTextSectionContainer>
  )
}

export default function FamilyPaymentOption(props) {
  const {
    imgUrl,
    title,
    payee,
    costPerMonth,
    mainText,
    bulletPoint1,
    bulletPoint2,
    bulletPoint3,
    activeResidents,
    onClick,
    isActive,
    preferredPeopleNominative
  } = props

  return (
    <CostOptionSectionContainer>
      <PaymentOptionBox
        $hasOnClick={!!onClick}
        $isActive={isActive}
        onClick={onClick}
      >
        {renderPayeeOptionTitle({ payee, onClick, isActive })}
        <GreyLine />
        {renderMonthlyCostSection({
          costPerMonth,
          activeResidents,
          preferredPeopleNominative
        })}
        <GreyLine />
        <CostImageContainer>
          <CostImage alt="" src={imgUrl} />
        </CostImageContainer>
        {renderCostTextSection({
          bulletPoint1,
          bulletPoint2,
          bulletPoint3,
          mainText
        })}
      </PaymentOptionBox>
    </CostOptionSectionContainer>
  )
}

// Styled Components

const CostOptionSectionContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
`

const PaymentOptionBox = styled.div`
  align-items: center;
  background: ${colors.white};
  border-radius: 4px;
  border: 1px solid ${(props) => (props.$isActive ? colors.pink : colors.grey)};
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  flex-grow: 1;
  cursor: ${(props) => (props.$hasOnClick ? 'pointer' : 'default')};

  ${(props) =>
    props.$hasOnClick &&
    `
    &:hover {
      border: 1px solid ${colors.pink};
    }
  `}
`

const PayeeOptionTitleContainer = styled.div`
  padding: 16px 0 16px 0;
  width: 100%;
  display: flex;
  justify-content: ${(props) =>
    props.$hasOnClick ? 'space-between' : 'center'};
  align-items: center;
`

const Spacer = styled.div`
  width: 24px;
`

const PayeeOptionTitle = styled.div`
  font-size: 18px;
  line-height: 32px;
`

const GreyLine = styled.div`
  height: 1px;
  background: ${colors.grey};
  width: 100%;
`

const MonthlyCostContainer = styled.div`
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const MonthlyCostTitle = styled.div`
  font-size: 18px;
  line-height: 32px;
  font-weight: bold;
`

const MonthlyCostSubtitle = styled.div`
  color: ${colors.darkgrey};
  margin-top: 8px;
  line-height: 18px;
  font-size: 12px;
`

const CostImageContainer = styled.div`
  margin: 28px 0 32px 0;
`

const CostImage = styled.img`
  height: 140px;
`

const CostTextSectionContainer = styled.div`
  margin-bottom: 14px;
`

const CostMainText = styled.div`
  font-size: 14px;
  line-height: 22px;
  ${(props) =>
    props.$marginBottom && `margin-bottom: ${props.$marginBottom}px;`}
`

const CostBulletPoints = styled.ul`
  padding-left: 20px;
  margin: 0;
`

const BulletItem = styled.li`
  padding-left: 5px;
`
